import apolloClient from "../graphql";
import { ORIGINANDDESTINATION } from "../graphql/checkinQueries";

export async function OriginAndDestination() {
  const response = await apolloClient.query({
    query: ORIGINANDDESTINATION,
    variables: {
      cultureCode: "en-US"
    }
  });
  const activeCities = response.data.cities?.values;
  const cityMap = new Map(activeCities.map((city) => [city.cityCode, city]));
  const activeAirports = response?.data?.stations?.values;
  const stationWithCityInfo = activeAirports.map((station) => ({
    ...station,
    cityInfo: cityMap.get(station.locationDetails.cityCode) || {}
  }));

  const newResponse = {
    data: {
      ...response.data,
      stations: {
        values: stationWithCityInfo
      }
    }
  };
  return newResponse;
}
